var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"top-content-list",class:{ isPC: _vm.$store.getters['camera/isPC'] }},_vm._l((_vm.list),function(data,index){return _c('li',{key:index,staticClass:"content-line"},[_c('div',{staticClass:"content-text"},[_vm._v(_vm._s(data))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }